import React from 'react';

import { Box, styled } from '@mui/material';
import PropTypes from 'prop-types';

import OverFreemiumOfferBanner from 'components/Banner/components/OverFreemiumOfferBanner';
import OverSeatOfferBanner from 'components/Banner/components/OverSeatOfferBanner';
import { useOverDateLimitOffer } from 'hooks/use-over-date-limit-offer';
import { useOverSeatLimitOffer } from 'hooks/use-over-seat-limit-offer';
import { planType } from 'utils/constants';

const Box_Bannerwrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'withMarginTop' && prop !== 'withMarginBottom',
})(({ theme, withMarginTop, withMarginBottom }) => ({
  marginTop: withMarginTop ? theme.spacing(5) : 0,
  marginBottom: withMarginBottom ? theme.spacing(5) : 0,
}));

export function BlockingBannerWhereYouHaveToPay({
  fullWidth,
  blockItemsCreation,
  bannerFromChildren,
  withMarginTop,
  withMarginBottom,
  notAvailableForFreeOffer,
}) {
  const { isOverSeatLimitOffer, currentPlan } = useOverSeatLimitOffer();
  const { isOverDateLimitOffer } = useOverDateLimitOffer();

  const dontShowBannerForFreeOffer =
    notAvailableForFreeOffer && currentPlan?.offer_type === planType.free;

  if (dontShowBannerForFreeOffer) {
    return null;
  }

  if (isOverDateLimitOffer) {
    return (
      <Box_Bannerwrapper withMarginTop={withMarginTop} withMarginBottom={withMarginBottom}>
        <OverFreemiumOfferBanner
          fullWidth={fullWidth}
          blockItemsCreation={blockItemsCreation}
          currentPlan={currentPlan}
        />
      </Box_Bannerwrapper>
    );
  }

  if (isOverSeatLimitOffer) {
    return (
      <Box_Bannerwrapper withMarginTop={withMarginTop} withMarginBottom={withMarginBottom}>
        <OverSeatOfferBanner
          currentPlan={currentPlan}
          fullWidth={fullWidth}
          blockItemsCreation={blockItemsCreation}
        />
      </Box_Bannerwrapper>
    );
  }

  if (bannerFromChildren) {
    return bannerFromChildren;
  }

  return null;
}

BlockingBannerWhereYouHaveToPay.propTypes = {
  fullWidth: PropTypes.bool,
  blockItemsCreation: PropTypes.bool,
  bannerFromChildren: PropTypes.node,
  withMarginTop: PropTypes.bool,
  withMarginBottom: PropTypes.bool,
  notAvailableForFreeOffer: PropTypes.bool,
};

export default BlockingBannerWhereYouHaveToPay;
